import { useMemo } from 'react';
import { useProjectDefinition } from './use-project-definition.js';
export function useDefinitionSchema(schemaCreator) {
    const { definitionSchemaParserContext } = useProjectDefinition();
    return useMemo(() => schemaCreator(definitionSchemaParserContext), [definitionSchemaParserContext, schemaCreator]);
}
//# sourceMappingURL=use-definition-schema.js.map